import React, { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';

/**
 * Password input with a show/hide eye toggle.
 * Drop-in replacement for `<Input type="password" />`.
 * Accepts all props of Input. Toggle is positioned inside the input (right).
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { className = '', 'data-testid': testId, ...props },
  ref
) {
  const [visible, setVisible] = useState(false);
  const toggleId = testId ? `${testId}-toggle` : 'password-visibility-toggle';

  return (
    <div className="relative">
      <Input
        {...props}
        ref={ref}
        type={visible ? 'text' : 'password'}
        data-testid={testId}
        className={`pr-10 ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        tabIndex={-1}
        data-testid={toggleId}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-mlt-text-muted hover:text-mlt-navy transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" strokeWidth={1.8} /> : <Eye className="w-4 h-4" strokeWidth={1.8} />}
      </button>
    </div>
  );
});

export default PasswordInput;
